import React, { FC } from 'react'
import styled from 'styled-components'

import Container from './Container'
import Nav from './Nav'

export type HomeProps = { className?: string }

const Home: FC<HomeProps> = ({ children, className }) => (
  <>
    <Container className={className}>
      <Nav />
      <div className="account-page-details">{children}</div>
    </Container>
  </>
)

Home.defaultProps = {
  className: '',
}

const StyledHome = styled(Home)(({ theme }) => ({
  '--nav-width': '264px',
  '--main-padding-l': '15px',
  '--main-padding-r': '15px',
  display: 'flex',
  flexDirection: 'column',
  '.account-page-details': {
    overflow: 'hidden',
    backgroundColor: theme.colors.coolGray.cool250,
    borderRight: `1px solid ${theme.colors.coolGray.cool450}`,
    paddingLeft: 'var(--main-padding-l)',
    paddingRight: 'var(--main-padding-r)',
    paddingTop: '20px',
    '.MuiFilledInput-root': {
      backgroundColor: theme.colors.grayscale.white,
    },
    '@media print': {
      borderRight: `1px solid ${theme.colors.grayscale.white}`,
    },
  },
  '@media(min-width: 768px)': {
    '--main-padding-l': '60px',
    '--main-padding-r': '60px',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '.account-page-details': {
      flex: '1',
      paddingTop: '40px',
    },
  },
  '@media(min-width: 1100px)': {
    flexWrap: 'nowrap',
    '.account-page-details': {
      flex: '1 1 700px',
      paddingBottom: '80px',
    },
  },
}))

export default StyledHome
